import React from 'react';

function ArrowSquareRight(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M19.75 22C20.9926 22 22 20.9926 22 19.75L22 4.25C22 3.00736 20.9926 2 19.75 2L4.25 2C3.00736 2 2 3.00736 2 4.25L2 19.75C2 20.9926 3.00736 22 4.25 22L19.75 22ZM12.0579 16.4328C11.814 16.1886 11.8143 15.7929 12.0585 15.549L14.9922 12.6194L7.60945 12.6194C7.26427 12.6194 6.98445 12.3396 6.98445 11.9944C6.98445 11.6492 7.26427 11.3694 7.60945 11.3694L14.9887 11.3694L12.0583 8.43963C11.8142 8.19558 11.8141 7.79985 12.0582 7.55575C12.3022 7.31164 12.698 7.3116 12.9421 7.55566L16.7651 11.3779C17.1071 11.7198 17.1069 12.2742 16.7648 12.6158L12.9418 16.4335C12.6976 16.6774 12.3018 16.6771 12.0579 16.4328Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowSquareRight;
